var render = function render(){var _vm=this,_c=_vm._self._c;return _c('AppButton',_vm._b({staticClass:"text-16-400 ctx-menu-btn border-radius-10",attrs:{"color":"grey-6","text-color":"black","padding":"8px 15px","icon-left-size":"16px","label-class":"q-pl-sm"},on:{"click":function($event){return _vm.$emit('click', $event)}}},'AppButton',_vm.$attrs,false))
}
var staticRenderFns = []

export { render, staticRenderFns }